import React, { useState } from "react";
import  { useEffect } from "react";
import Slider from "react-slick";
import { Grid, Typography, Container, Button } from "@mui/material";

import bannerimg from "../assets/images/ubiquiti-transparent1.png";
import bannerimg2 from "../assets/images/89161553346861.png";
import productimg from "../assets/images/product-img.png";
import product01 from "../assets/images/ctgr-img1.jpg";
import product02 from "../assets/images/ctgr-img2.jpg";
import product03 from "../assets/images/ctgr-img3.jpg";
import product04 from "../assets/images/ctgr-img4.jpg";
import logo1 from "../assets/images/logo1.png";
import logo2 from "../assets/images/logo2.png";
import logo3 from "../assets/images/logo3.png";
import logo4 from "../assets/images/logo4.png";
import logo5 from "../assets/images/logo5.png";
import logo6 from "../assets/images/logo6.png";
import logo7 from "../assets/images/logo7.png";
import logo8 from "../assets/images/logo8.png";
import logo9 from "../assets/images/logo9.png";
import man from "../assets/images/pexels-photo.png";

import items from "../assets/images/items.png";
import TextField from "@mui/material/TextField";
import HDK79EC2 from "../assets/images/HDK-79EC2.jpg"
import {Link} from "react-router-dom"
import JVCAV from "../assets/images/JVCAV.jpg"
import JVCAVPRO from "../assets/images/JVCAVPRO.jpg"
import JVCDV from "../assets/images/JVCDV.jpg"
import JVCKV from "../assets/images/JVCKV.jpg"
import NexioNxAmpImage from "../assets/images/NexioNxAmpImage.png"
import canon1 from "../assets/images/Canon1.jpg"
import canon2 from "../assets/images/Canon2.avif"
import canon3 from "../assets/images/Canon3.avif"
import canon4 from "../assets/images/Canon4.jpg"
import sony from "../assets/images/sony.png"
import KOMODO from "../assets/images/KOMODO.png"
import Manfrotto from "../assets/images/Manfrotto.png"
import Steadicam from "../assets/images/Steadicam.png"
import AOS from "aos";


// icons
import {  FaArrowRightLong } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {


  const [title, setTitle] = useState("The BroadCast Store -  Buy Professional Equipment for Video Production");
  const [description, setDescription] = useState("Broadcast Store provides a wide selection of professional audiovisual equipment at competitive prices, allowing customers to get top-notch service department.");

  useEffect(() => {
    document.title = title;
    document.getElementById('meta-description').setAttribute('content', description);
  }, [title, description]);


  useEffect(()=>{
    AOS.init({duration:2000});
    window.scrollTo(0, 0);

}, [])
  const [activeTab, setActiveTab] = useState("London");
  const openCity = (cityName) => {
    setActiveTab(cityName);
  };

  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  var logos = {
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: "linear",
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  };

  return (
    <Grid>
      <Grid className="banner">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Grid className="prod-banner">
                <Grid className="prod-banner-txt">
                  <Typography variant="h1">
                  Professional WiFi at your business?
                  </Typography>
                  <Typography variant="p">
                  Wireless network and internet connections are becoming increasingly important.
                  </Typography>
                  <Button className="theme-btn">
                    <Link to={"/Wifi"}>Read More</Link>
                  </Button>
                </Grid>
                <img src={bannerimg} alt="" />
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid className="prod-banner2">
                <Grid className="prod-banner-txt2">
                  <Typography variant="h2">
                  Google Chromecast With Google TV{" "}
                  </Typography>
                  <img src={bannerimg2} alt="" />
                  <Typography variant="h3">$123.00</Typography>
                </Grid>
                <Button>
                  <Link to={"/Chromecast"}>
                  <FaArrowRight />
                  </Link>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid className="ftured-sec">
        <Container>
          <Grid className="head-title">
            <Typography variant="h2">Featured Products</Typography>
          </Grid>
          <Slider {...settings}>

            <Grid className="ftrd-slide">
              <Grid className="ftrd-slide-blk">
                <Grid className="prod-img">
                  <Typography variant="h6">-20%</Typography>
                  <img src={NexioNxAmpImage} alt="" />
                </Grid>
                <Grid className="pro-disp">
                  <Grid className="prod-sku">
                    <Typography variant="body">SKU#</Typography>
                    <Typography variant="body">EQ702438U</Typography>
                  </Grid>
                  <Typography variant="h5">
                  Harris NEXIO NX AMP 3801 HDI
                  </Typography>
                  <p className="body">
                  Broadcast video server integrated with 8SD or 4 HD channels, with channelView option and 4TB RAID

                  </p>
                  
                  <Typography variant="h6">Call for Price</Typography>
                  <Button className="theme-btn">
                    <Link to={'/nexioNxAmp'}>READ MORE</Link>
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="ftrd-slide">
              <Grid className="ftrd-slide-blk">
                <Grid className="prod-img">
                  <Typography variant="h6">-20%</Typography>
                  <img src={JVCAV} alt="" />
                </Grid>
                <Grid className="pro-disp">
                  <Grid className="prod-sku">
                    <Typography variant="body">SKU#</Typography>
                    <Typography variant="body">MO662561</Typography>
                  </Grid>
                  <Typography variant="h5">
                  JVC AV-P1000U
                  </Typography>
             
                  <p className="body">
                  SXGA DIGITAL PRESENTER

                  </p>
                  <Typography variant="h6">Call for Price</Typography>
                  <Button className="theme-btn">
                    <Link to={"/Jvcav"}>READ MORE</Link>
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="ftrd-slide">
              <Grid className="ftrd-slide-blk">
                <Grid className="prod-img">
                  <Typography variant="h6">-20%</Typography>
                  <img src={JVCAVPRO} alt="" />
                </Grid>
                <Grid className="pro-disp">
                  <Grid className="prod-sku">
                    <Typography variant="body">SKU#</Typography>
                    <Typography variant="body">MO662561</Typography>
                  </Grid>
                  <Typography variant="h5">
                  JVC AV-P750U
                  </Typography>
                
                  <p className="body">
                  The AV-P750U has am adjustable 5 position camera arm and rotate camera head to present objects from any angle.

                  </p>
                  <Typography variant="h6">Call for Price
</Typography>
                  <Button className="theme-btn">
                    <Link to={'/Jvcavp'}>READ MORE</Link>
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="ftrd-slide">
              <Grid className="ftrd-slide-blk">
                <Grid className="prod-img">
                  <Typography variant="h6">-20%</Typography>
                  <img src={JVCDV} alt="" />
                </Grid>
                <Grid className="pro-disp">
                  <Grid className="prod-sku">
                    <Typography variant="body">SKU#</Typography>
                    <Typography variant="body">MO796116</Typography>
                  </Grid>
                  <Typography variant="h5">
                  JVC DV115
                  </Typography>
                
                  <p className="body">
                  The DV115 is a light weight pan & tilt head especially optimized for the JVC GY-DV300REM camcorder. 

                  </p>
                  <Typography variant="h6">Call for Price</Typography>
                  <Button className="theme-btn">
                    <Link to={"/Jvcdv"}>READ MORE</Link>
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="ftrd-slide">
              <Grid className="ftrd-slide-blk">
                <Grid className="prod-img">
                  <Typography variant="h6">-20%</Typography>
                  <img src={JVCKV} alt="" />
                </Grid>
                <Grid className="pro-disp">
                  <Grid className="prod-sku">
                    <Typography variant="body">SKU#</Typography>
                    <Typography variant="body">MO17392</Typography>
                  </Grid>
                  <Typography variant="h5">
                  JVC KY-F32U
                  </Typography>
                 
                  <p className="body">
                  3-CCD General Purpose Camera Less Lens

                  </p>
                  <Typography variant="h6">$4,171.90</Typography>
                  <Button className="theme-btn">
                    <Link to={'/Jvcky'}>READ MORE</Link>
                  </Button>
                </Grid>
              </Grid>
            </Grid>

          </Slider>
        </Container>
      </Grid>

      <Grid className="partners-sec">
        <Slider {...logos}>
          <Grid className="slide-logo">
            <img src={logo1} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo2} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo3} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo4} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo5} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo6} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo7} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo8} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo9} alt="" />
          </Grid>
          <Grid className="slide-logo">
            <img src={logo1} alt="" />
          </Grid>
        </Slider>
      </Grid>

      <Grid className="all-prod-sec">
        <Container>
          <Grid className="head-title">
            <Typography variant="h2">All Products</Typography>
          </Grid>



          <Grid
            id="London"
            className={`tabcontent ${activeTab === "London" ? "active" : ""}`}
          >
            <Grid container spacing={2}>
           
               <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={product01} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO814260</Typography>
                      </Grid>
                      <Typography variant="h5">
                      The broadcast store 1 Inch Type C transfer to digital file
                      </Typography>
                      <p className="body">
                      1 inch C Format videotape digitized to Quicktime file or other file formats
                      </p>
                     
                      
                      <Button className="theme-btn">
                        <Link to={'/broadcaststore1inchtype'}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={product02} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO818457</Typography>
                      </Grid>
                      <Typography variant="h5">
                      The broadcast store 10,000 Beta or DigiBetacam video tapes
                      </Typography>
                      <p className="body">
                      SPECIAL OFFER: 10,000 Beta or DigiBetacam video tapes digitized before the end of this year.
                      </p>
                     
                      
                      <Button className="theme-btn">
                        <Link to={"/broadcaststoreBeta"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={product03} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO814261</Typography>
                      </Grid>
                      <Typography variant="h5">
                      The broadcast store 2 Inch Quadruplex transfer to digital file
                      </Typography>
                      <p className="body">
                      2 inch Quad format videotape reformatted to Digital file
                        
                      </p>
                      
                      
                      <Button className="theme-btn">
                        <Link to={"/broadcaststore2InchQuadruplex"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={product04} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO814262</Typography>
                      </Grid>
                      <Typography variant="h5">
                      The broadcast store 3/4 Inch U-Matic tape transfer to digital file
                      </Typography>
                      <p className="body">
                      3/4", Umatic and Umatic SP videotape reformatted to Digital file
                        
                      </p>
                   
                     
                      <Button className="theme-btn">
                        <Link to={"/broadcaststoreMatictape"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>



            </Grid>
            <Grid container spacing={2} mt={2}>
             
               <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={canon1} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO21751</Typography>
                      </Grid>
                      <Typography variant="h5">
                      Canon XL1S
                      </Typography>
                      <p className="body">
                      3CCD Digital Video Camcorder

                      </p>
                     
                      <Button className="theme-btn">
                        <Link to={"/CanonXL1S"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
             
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={canon2} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO797443N</Typography>
                      </Grid>
                      <Typography variant="h5">
                      Canon XL2
                      </Typography>
                      <p className="body">
                      3 CCD Digital Video Camera
                        
                      </p>
                      
                      <Button className="theme-btn">
                        <Link to={"/CanonXL2"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={canon3} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">MO815722</Typography>
                      </Grid>
                      <Typography variant="h5">
                      Canon DVM-E60
                      </Typography>
                      <p className="body">
                      60-minute Digital Videocassette
                        
                      </p>
                      
                      <Button className="theme-btn">
                        <Link to={"/CanonDVM"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
             
              <Grid item xs={3}>
                <Grid className="ftrd-slide">
                  <Grid className="ftrd-slide-blk">
                    <Grid className="prod-img">
                      <Typography variant="h6">-20%</Typography>
                      <img src={canon4} alt="" />
                    </Grid>
                    <Grid className="pro-disp">
                      <Grid className="prod-sku">
                        <Typography variant="body">SKU#</Typography>
                        <Typography variant="body">EQ706657N</Typography>
                      </Grid>
                      <Typography variant="h5">
                      Canon DIGI-SUPER 70x
                      </Typography>
                      <p className="body">
                      70x zoom and wide angle Broadcast Television Lens
                        
                      </p>
                  
                      <Button className="theme-btn">
                        <Link to={"/CanonDIGI"}>Read More</Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>


        </Container>
      </Grid>

      <Grid id="pro-cards">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={7}>
              <Grid id="inner-card" className="blue">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Grid className="content">
                      <Typography variant="h2">
                      A4Tech HS-8i Stereo Headset
                      </Typography>
                      <Typography variant="body1">
                      The soft ear-pad covers comfortably on the ear to provide absolute sound quality as if you're in your own world.
                      </Typography>
                      <Button className="arrow-btn">
                        <Link to={"/A4Techheadset"}>
                          Buy Now <FaArrowRightLong />{" "}
                        </Link>
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid className="image">
                      <img src={man} alt="" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={5}>
              <Grid id="inner-card" className="yellow">
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Grid className="content">
                      <Typography variant="h2">iPad Pro
Supercharged by</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid className="content">
                      <Button className="arrow-btn">
                        <Link to={"/Ipadpro"}>
                        Buy Now Instantly <FaArrowRightLong />{" "}
                        </Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Grid className="image">
                      <img src={Manfrotto} alt="" />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid className="image image-mob">
                      <img src={Steadicam} alt="" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid id="pro-cards">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Grid id="inner-card" className="green">
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Grid className="content">
                      <Typography variant="h2">
                      Sony HDC-3500L
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid className="content">
                      <Button className="arrow-btn">
                        <Link to={"/Applemonitor"}>
                          Click Here To View All <FaArrowRightLong />{" "}
                        </Link>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid className="image">
                      <img src={sony} alt="" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7}>
              <Grid id="inner-card" className="d-blue">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Grid className="content">
                      <Typography variant="h2">
                      RED DIGITAL CINEMA <br />
                      KOMODO-X 
                      </Typography>
                      <Typography variant="body1">
                      KOMODO-X™ is the next evolution in the KOMODO family, multiplying the frame rates, dynamic range, and usability of the original KOMODO to break new grounds.{" "}
                      </Typography>
                      <Button className="arrow-btn">
                        <Link to={"/SpeakerAlesis"}>
                          Click Here To View All <FaArrowRightLong />{" "}
                        </Link>
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid className="image">
                      <img src={KOMODO} alt="" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid id="newsletter">
        <Container>
          <Grid className="news-con">
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h2">Sign Up for Newsletter</Typography>
                <Typography variant="body1">
                Receive new updates on seasonal update,
                  <br /> security updates, promotional updates.{" "}
                </Typography>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Grid className="textField">
                    <TextField
                      id="outlined-basic"
                      label="Name"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid className="textField">
                    <TextField
                      id="outlined-basic"
                      label="Email"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid className="sbmt-btn">
                    <Button className="submt">
                      <Link to={"/"}>Submit</Link>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

  


    </Grid>
  );
};

export default Home;
